export const siteSettings = {
  name: "Prime Market Pro",
  link: "https://primemarketpro.net",
  email: "support@primemarketpro.net",
  appLink: "https://app.primemarketpro.net",
};
